module.exports = __webpack_public_path__ + "img/sender-company-disabled.5a4aa302.svg";